import React, { FC, useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import LinkMaterial from "@material-ui/core/Link";
import { Link } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Title from "../../components/Title";
import TextFieldComponent from "../../components/TextFieldComponent";
import TextFieldPassword from "../../components/TextFieldPassword";
import ButtonComponent from "../../components/ButtonComponent";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import { utilities } from "../../helpers/utilities";
import * as Validations from "../../helpers/validations";
import UserModel from "../../models/user-model";
import { modules }  from '../../constants/serverErrors-constants';
import { AuthReducerState } from "../../flux/reducers/auth-reducer";
import { login, clearAuthLoading } from "../../flux/actions/auth-actions";
import ScreenLoader from "../../components/ScreenLoader";
import { useStyles } from "./styles";


const Login: FC = () => {
  const classes = useStyles();
  const dispatcher = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const user: UserModel = useSelector((state: any) => state.authReducer.user);
  const authReducer: AuthReducerState = useSelector(
    (state: any) => state.authReducer
  );

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({ password: "", email: "", login: "" });
  const [showPassword] = useState(false);
  
  const redirect = location.search? location.search.split('=')[1] : '/';

  useEffect(() => {
    dispatcher(clearAuthLoading());
  }, [dispatcher]);

  useEffect(() => {
    if (authReducer.errorStatus === 422 && authReducer.errorMessage?.includes(modules.EMAIL_OR_PASSWORD_ERROR)) {
      setErrors({ ...errors, login: "Usuario o contraseña son inválidos" });
    }
  }, [authReducer.errorStatus]);

  useEffect(() => {
    if (user && user.id) history.push(redirect);
  }, [user]);

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const emailErrors = Validations.validate(
      [Validations.required, Validations.emailText],
      email
    );
    const passwordErrors = Validations.validate(
      [Validations.required, Validations.maxLength50, Validations.minLength6],
      password
    );

    setErrors({
      email: emailErrors,
      password: passwordErrors,
      login: "",
    });

    if (emailErrors || passwordErrors) return;
    dispatcher(login({ user: { email, password } }));
  };

  return (
    <Container component="main" maxWidth="sm">
      <ScreenLoader isOpen={authReducer.loading} />
      <form className={classes.form} onSubmit={onSubmit}>
        <Title value="Ingresar" />
        <TextFieldComponent
          error={utilities.returnErrorFlag(errors.email)}
          helperText={errors.email}
          label={"Email"}
          type="text"
          onChange={(e) => {
            setEmail(e.target.value.trim());
            setErrors({ ...errors, email: "" });
          }}
        />

        <TextFieldPassword
          error={utilities.returnErrorFlag(errors.password)}
          helperText={errors.password}
          label={"Contraseña"}
          onChange={(e) => {
            setPassword(e.target.value);
            setErrors({ ...errors, password: "" });
          }}

        />

        <Grid
          container
          wrap="nowrap"
          justify="center"
          alignItems="center"
          direction="column"
        >
          <Typography color="error">{errors.login}</Typography>
          <ButtonComponent value="Entrar" type="submit" color="secondary" variant="contained"/>
        </Grid>
        <Grid container wrap="nowrap" justify="center" alignItems="center">
          <Link to="signup" className="text-normalize-black"><span>Registrate</span></Link>
        </Grid>
        <Grid container wrap="nowrap" justify="center" alignItems="center">
          <Link to="renewPassword" className="text-normalize-black"><span>¿Olvidaste tu contraseña?</span></Link>
        </Grid>
      </form>
    </Container >
  );
};

export default Login;
